<!-- <div class="spacer"></div> -->

<div class="main">
  <div class="row">
    <div class="col" id="col1">Div 1</div>
    <div class="col" id="col2">Div 2</div>
    <div class="col" id="col3">Div 3</div>
    <div class="col" id="col4">Div 4</div>
    <div class="col" id="col5">Div 5</div>
    <div class="col" id="col6">Div 6</div>
    <div class="col" id="col7">Div 7</div>
    <div class="col" id="col8">Div 8</div>
    <div class="col" id="col9">Div 9</div>
    <div class="col" id="col10">Div 10</div>
    <div class="col" id="col11">Div 11</div>
    <div class="col" id="col12">Div 12</div>
  </div>
</div>

<div class="spacer"></div> <!-- Extra space added -->
